import { useBreakpoint } from './useBreakpoint'

// Телефон и любой сенсорный экран: разделы кабинета открывают из облачка,
// а не из бокового меню. Условие повторяет $compact-menu из styles/_breakpoints.scss
export const useIsCompactMenu = (): boolean => {
  const { isPhone, isTouch } = useBreakpoint()

  return isPhone || isTouch
}
